// Imports
////=require jquery/dist/jquery.min.js

var MyApp = {
    marketPlace: function() {

        if($('#busqueda').val() != ''){
            $('.form__submit').addClass('active');
        }

        $( "#busqueda" ).focus(function() {
            $('.form__submit').addClass('focus');
        }).focusout(function() {
            $('.form__submit').removeClass('focus');
        }).keyup(function() {         
            if($(this).val() != ''){
                $('.form__submit').addClass('active');
            }
            if($(this).val() === ''){
                $('.form__submit').removeClass('active');
            }
        });

        var phaterSection = $('#seeMore').parent();        
        $(window).on('resize', function(){
            //Recoger clases padres para retornar los ids
            $(phaterSection).each(function(){
                //Id section
                var IDs = $(this).attr('id');
                //variable global
                var item = $('#'+IDs+' .item');
                var x = 0;
                //validar resize
                if($(window).outerWidth() < 992){
                    //recorrer items por padre Id
                    item.each(function(i){
                        if(!$(this).hasClass('item--collapse')){
                            $(this).removeAttr('style')
                        }
                        if(x <= 7){
                            $(this).removeClass('item--collapse');
                            
                        }
                        x++;
                    });
                }
                if($(window).outerWidth() > 992){
                    //recorrer items por padre Id
                    if($('#seeMore').hasClass('active')){
                        $('.item--collapse').attr("style","display: list-item")
                    }
                    item.each(function(i){
                        if(x >= 6){
                            $(this).addClass('item--collapse');
                        }
                        x++;
                    });
                }
            });            
        });
        $(window).resize();

        $('.nateevo-marketPlace-solution .list').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: true,
            arrows: false,
            responsive: [
                {
                  breakpoint: 1090,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 350,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });
    }
}
$(function () {
    MyApp.marketPlace();
});

function seeMoreItems(element, idContent) {
    $(element).parent().find('.btn').toggleClass('active');
    var phaterSection = $(idContent).attr('id');
    // collapse para los que tengan la clase
    var itemCollapse = $('#'+phaterSection).find('.item--collapse');
    itemCollapse.slideToggle();
}

function seeMoreDetails(id) {
    $('.marketPlace-categories__content').hide();
    $('.marketPlace-categories__back').fadeIn();
    $(id).fadeIn();
}

function backCategory(element) {
    $(element).parent().hide();
    $('.marketPlace-detailCat').hide();
    $('.marketPlace-result').hide();
    $('.marketPlace-categories__content').fadeIn();
}
